import script from "./search-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-input.vue?vue&type=script&setup=true&lang=ts"

import "./search-input.vue?vue&type=style&index=0&id=4bc21dbd&lang=css"

const __exports__ = script;

export default __exports__